/**
 * @author HungNS
 */
import BaseService from "./BaseService";
import {ROOT, DEPOSIT} from "./_base";

class DepositService extends BaseService {

    async initDeposit(msg) {
        const response = await this.getByUri(`${ROOT}/${DEPOSIT}/init-deposit?msg=` + msg);
        return response.data
    }

    async getBankVeritrans() {
        const response = await this.getByUri(`${ROOT}/${DEPOSIT}/veritrans-bank-list`);
        return response.data
    }

    async checkVirtualBank() {
        const response = await this.getByUri(`${ROOT}/${DEPOSIT}/check-virtual-bank`);
        return response.data
    }

    async createVirtualBank() {
        const response = await this.getByUri(`${ROOT}/${DEPOSIT}/create-virtual-bank`);
        return response.data
    }

    async depositConfirmCheck(params) {
        const response = await this.get(`${ROOT}/${DEPOSIT}/deposit-confirm-check`, params);
        return response.data
    }
}
export default DepositService;